import { getEditLocation } from "../../../core/util/functions";
export const paymentLocation = "/reports/payments";
export const getPaymentEditLocation = (id?: string) =>
  getEditLocation(paymentLocation, undefined, id);

export const editRouter = getPaymentEditLocation(":payId?");
